module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Direction#1-017652b978105a9bf7e413c29525e67e.svg";